// src/pages/MentionsLegales.jsx
import { Container, Typography, Box, Paper, keyframes } from "@mui/material";

// Animation fade-in + slide-up
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export default function MentionsLegales() {
    return (
        <Container maxWidth="md" sx={{ mt: 6, mb: 6 }}>

            <Typography
                variant="h3"
                sx={{
                    mb: 4,
                    animation: `${fadeInUp} 0.6s ease-out`,
                }}
            >
                Mentions légales
            </Typography>

            <Paper
                elevation={0}
                sx={{
                    p: 3,
                    border: "1px solid #e5e5e5",
                    borderRadius: 2,
                    animation: `${fadeInUp} 0.8s ease-out`,
                }}
            >
                {/* Présentation */}
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
                    Présentation du site
                </Typography>

                <Typography sx={{ mb: 2 }}>
                    En vertu des lois en vigueur, il est précisé aux utilisateurs du site
                    <strong> www.321-timing.ch </strong> l'identité des différents intervenants
                    dans le cadre de sa réalisation et de son suivi.
                </Typography>

                <Typography sx={{ mb: 2 }}>
                    Le présent site est édité par :
                    <br />
                    <strong>321‑TIMING.ch</strong>, Association à but non lucratif,
                    <br />
                    c/o Stéphane Veya, CP 360, 1920 Martigny

                </Typography>
                <Typography sx={{ mb: 2 }}>CHE-290.869.355</Typography>

                {/* Responsable */}
                <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
                    Responsable de la publication et webmaster
                </Typography>

                <Typography sx={{ mb: 2 }}>
                    Christoph Wenger, joignable par email :
                    <br />
                    <strong>info@321-timing.ch</strong>
                </Typography>

                {/* Hébergeur */}
                <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
                    Hébergeur du site
                </Typography>

                <Typography sx={{ mb: 2 }}>
                    Infomaniak Network SA
                    <br />
                    Rue Eugène-Marziano 25, 1227 Les Acacias, Genève
                    <br />
                    Téléphone : +41 22 820 35 55
                </Typography>

                {/* Propriété intellectuelle */}
                <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
                    Propriété intellectuelle et contrefaçons
                </Typography>

                <Typography sx={{ mb: 2 }}>
                    L’association 321‑TIMING.ch est propriétaire des droits de propriété
                    intellectuelle ou détient les droits d’usage sur tous les éléments
                    accessibles sur le site, notamment : les textes, les images, les
                    graphismes, le logo, les icônes.
                </Typography>

                <Typography sx={{ mb: 2 }}>
                    Toute reproduction, représentation, modification, publication ou
                    adaptation de tout ou partie des éléments du site, quel que soit le
                    moyen ou le procédé utilisé, est interdite, sauf autorisation écrite
                    préalable de l’association.
                </Typography>

                {/* Cookies */}
                <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
                    Cookies et traceurs
                </Typography>

                <Typography sx={{ mb: 2 }}>
                    Le site www.321-timing.ch ne collecte aucun cookie et ne dépose aucun
                    traceur sur votre navigateur.
                </Typography>

                {/* Mesure d’audience */}
                <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
                    Mesure d’audience
                </Typography>

                <Typography sx={{ mb: 2 }}>
                    Une mesure d’audience minimale est effectuée au niveau du serveur afin
                    d’analyser le trafic général du site (nombre de visites, provenance,
                    etc.).
                </Typography>

                {/* Réseaux sociaux */}
                <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
                    Réseaux sociaux
                </Typography>

                <Typography sx={{ mb: 2 }}>
                    Les boutons de partage vers les réseaux sociaux ne déposent aucun
                    cookie. Les adresses e‑mail fournies via un formulaire de contact ne
                    sont jamais transmises à des tiers.
                </Typography>

                {/* Liens hypertextes */}
                <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
                    Liens hypertextes
                </Typography>

                <Typography sx={{ mb: 2 }}>
                    Le site contient des liens vers d’autres sites. 321‑TIMING.ch n’a pas
                    la possibilité de vérifier le contenu de ces sites et n’assume aucune
                    responsabilité à ce titre.
                </Typography>

                {/* Adresse */}
                <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
                    Adresse
                </Typography>

                <Typography sx={{ mb: 2 }}>
                    321‑TIMING.ch
                    <br />
                    c/o Stéphane Veya, CP 360
                    <br />
                    1920 Martigny
                    <br />
                    <strong>info@321-timing.ch</strong>
                </Typography>
                <Typography sx={{ mb: 2 }}>
                    <strong>Coordonnées bancaires:</strong>
                    <br />
                    IBAN: CH77 0900 0000 1689 5209 9 (Postfinance)
                    <br />
                    321-timing.ch, 1920 Martigny
                    <br />

                </Typography>
            </Paper>
        </Container>
    );
}
